import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function UserContact() {
  return (
    <div>
        <UserHeader/>
    <main className="main">
  <nav aria-label="breadcrumb" className="breadcrumb-nav border-0 mb-0">
    <div className="container">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><a href="index.html">Home</a></li>
        <li className="breadcrumb-item"><a href="#">Pages</a></li>
        <li className="breadcrumb-item active" aria-current="page">Contact us</li>
      </ol>
    </div>{/* End .container */}
  </nav>{/* End .breadcrumb-nav */}
  <div className="container">
    <div className="page-header page-header-big text-center" style={{backgroundImage: 'url("asset/images/contact-header-bg.jpg")'}}>
      <h1 className="page-title text-white">Contact us<span className="text-white">keep in touch with us</span></h1>
    </div>{/* End .page-header */}
  </div>{/* End .container */}
  <div className="page-content pb-0">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 mb-2 mb-lg-0">
          <h2 className="title mb-1">Contact Information</h2>{/* End .title mb-2 */}
          <p className="mb-3">Vestibulum volutpat, lacus a ultrices sagittis, mi neque euismod dui, eu pulvinar nunc sapien ornare nisl. Phasellus pede arcu, dapibus eu, fermentum et, dapibus sed, urna.</p>
          <div className="row">
            <div className="col-sm-7">
              <div className="contact-info">
                <h3>The Office</h3>
                <ul className="contact-list">
                  <li>
                    <i className="icon-map-marker" />
                    Rohtak,India
                  </li>
                  <li>
                    <i className="icon-phone" />
                    <a href="tel:#">+91 0000000000</a>
                  </li>
                  <li>
                    <i className="icon-envelope" />
                    <a href="mailto:#">ss@gmail.com</a>
                  </li>
                </ul>{/* End .contact-list */}
              </div>{/* End .contact-info */}
            </div>{/* End .col-sm-7 */}
            <div className="col-sm-5">
              <div className="contact-info">
                <h3>The Office</h3>
                <ul className="contact-list">
                  <li>
                    <i className="icon-clock-o" />
                    <span className="text-dark">Monday-Saturday</span> <br />11am-7pm ET
                  </li>
                  <li>
                    <i className="icon-calendar" />
                    <span className="text-dark">Sunday</span> <br />11am-6pm ET
                  </li>
                </ul>{/* End .contact-list */}
              </div>{/* End .contact-info */}
            </div>{/* End .col-sm-5 */}
          </div>{/* End .row */}
        </div>{/* End .col-lg-6 */}
        <div className="col-lg-6">
          <h2 className="title mb-1">Got Any Questions?</h2>{/* End .title mb-2 */}
          <p className="mb-2">Use the form below to get in touch with the sales team</p>
          <form action="#" className="contact-form mb-3">
            <div className="row">
              <div className="col-sm-6">
                <label htmlFor="cname" className="sr-only">Name</label>
                <input type="text" className="form-control" id="cname" placeholder="Name *" required />
              </div>{/* End .col-sm-6 */}
              <div className="col-sm-6">
                <label htmlFor="cemail" className="sr-only">Email</label>
                <input type="email" className="form-control" id="cemail" placeholder="Email *" required />
              </div>{/* End .col-sm-6 */}
            </div>{/* End .row */}
            <div className="row">
              <div className="col-sm-6">
                <label htmlFor="cphone" className="sr-only">Phone</label>
                <input type="tel" className="form-control" id="cphone" placeholder="Phone" />
              </div>{/* End .col-sm-6 */}
              <div className="col-sm-6">
                <label htmlFor="csubject" className="sr-only">Subject</label>
                <input type="text" className="form-control" id="csubject" placeholder="Subject" />
              </div>{/* End .col-sm-6 */}
            </div>{/* End .row */}
            <label htmlFor="cmessage" className="sr-only">Message</label>
            <textarea className="form-control" cols={30} rows={4} id="cmessage" required placeholder="Message *" defaultValue={""} />
            <button type="submit" className="btn btn-outline-primary-2 btn-minwidth-sm">
              <span>SUBMIT</span>
              <i className="icon-long-arrow-right" />
            </button>
          </form>{/* End .contact-form */}
        </div>{/* End .col-lg-6 */}
      </div>{/* End .row */}
      <hr className="mt-4 mb-5" />
      <div className="stores mb-4 mb-lg-5">
        <h2 className="title text-center mb-3">Our Stores</h2>{/* End .title text-center mb-2 */}
        <div className="row">
          <div className="col-lg-6">
            <div className="store">
              <div className="row">
                <div className="col-sm-5 col-xl-6">
                  <figure className="store-media mb-2 mb-lg-0">
                    <img src="asset/images/stores/img-1.jpg" alt="image" />
                  </figure>{/* End .store-media */}
                </div>{/* End .col-xl-6 */}
                <div className="col-sm-7 col-xl-6">
                  <div className="store-content">
                    <h3 className="store-title">Wall Street Plaza</h3>{/* End .store-title */}
                    <address>New Delhi, India</address>
                    <div><a href="tel:#">+91 00000000</a></div>
                    <h4 className="store-subtitle">Store Hours:</h4>{/* End .store-subtitle */}
                    <div>Monday - Saturday 11am to 7pm</div>
                    <div>Sunday 11am to 6pm</div>
                    <a href="#" className="btn btn-link" target="_blank"><span>View Map</span><i className="icon-long-arrow-right" /></a>
                  </div>{/* End .store-content */}
                </div>{/* End .col-xl-6 */}
              </div>{/* End .row */}
            </div>{/* End .store */}
          </div>{/* End .col-lg-6 */}
          <div className="col-lg-6">
            <div className="store">
              <div className="row">
                <div className="col-sm-5 col-xl-6">
                  <figure className="store-media mb-2 mb-lg-0">
                    <img src="asset/images/stores/img-2.jpg" alt="image" />
                  </figure>{/* End .store-media */}
                </div>{/* End .col-xl-6 */}
                <div className="col-sm-7 col-xl-6">
                  <div className="store-content">
                    <h3 className="store-title">One New York Plaza</h3>{/* End .store-title */}
                    <address>88 Pine St, New York, NY 10005, USA</address>
                    <div><a href="tel:#">+1 987-876-6543</a></div>
                    <h4 className="store-subtitle">Store Hours:</h4>{/* End .store-subtitle */}
                    <div>Monday - Friday 9am to 8pm</div>
                    <div>Saturday - 9am to 2pm</div>
                    <div>Sunday - Closed</div>
                    <a href="#" className="btn btn-link" target="_blank"><span>View Map</span><i className="icon-long-arrow-right" /></a>
                  </div>{/* End .store-content */}
                </div>{/* End .col-xl-6 */}
              </div>{/* End .row */}
            </div>{/* End .store */}
          </div>{/* End .col-lg-6 */}
        </div>{/* End .row */}
      </div>{/* End .stores */}
    </div>{/* End .container */}
    <div id="map" />{/* End #map */}
  </div>{/* End .page-content */}
</main>

        <UserFooter/>
    </div>
  )
}

export default UserContact